module.exports = __webpack_public_path__ + "img/10@2x.9dfe37b6.png";